import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { isMobileWebview } from '../utils/isMobileWebview';
import './MobileBenefitsModal.css';

const MobileBenefitsModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if device is mobile (not desktop)
    const checkMobile = () => {
      const isMobileDevice = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      const isWebview = isMobileWebview();
      
      // Show modal only on mobile devices that are NOT webviews
      setIsMobile(isMobileDevice && !isWebview);
      
      // Check if modal was already dismissed in this session
      const dismissed = sessionStorage.getItem('mobileBenefitsModalDismissed');
      if (isMobileDevice && !isWebview && !dismissed) {
        setIsOpen(true);
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    // Remember dismissal for this session
    sessionStorage.setItem('mobileBenefitsModalDismissed', 'true');
  };

  if (!isMobile || !isOpen) {
    return null;
  }

  const modalContent = (
    <div className="mobile-benefits-modal-overlay" onClick={handleClose}>
      <div className="mobile-benefits-modal" onClick={(e) => e.stopPropagation()}>
        <button className="mobile-benefits-close" onClick={handleClose}>×</button>
        <div className="mobile-benefits-content">
          <h2>Start for Free</h2>
          <p className="mobile-benefits-subtitle">Unlock powerful reading resources</p>
          
          <div className="mobile-benefits-list">
            <div className="mobile-benefit-item">
              <span className="mobile-benefit-icon">📚</span>
              <div>
                <h3>AI-Powered Summaries</h3>
                <p>Get comprehensive, detailed summaries of any book</p>
              </div>
            </div>
            
            <div className="mobile-benefit-item">
              <span className="mobile-benefit-icon">💬</span>
              <div>
                <h3>Interactive Q&A</h3>
                <p>Ask questions and get intelligent answers about any book</p>
              </div>
            </div>
            
            <div className="mobile-benefit-item">
              <span className="mobile-benefit-icon">📖</span>
              <div>
                <h3>Study Guides</h3>
                <p>Generate chapter-by-chapter guides for book clubs and study</p>
              </div>
            </div>
            
            <div className="mobile-benefit-item">
              <span className="mobile-benefit-icon">⭐</span>
              <div>
                <h3>Personal Library</h3>
                <p>Save your favorite books and track your reading journey</p>
              </div>
            </div>
          </div>
          
          <button className="mobile-benefits-cta" onClick={handleClose}>
            Get Started
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default MobileBenefitsModal;
